import { gql } from '@apollo/client';

export const EXPORT_PRICING_FAILURE_REVISION_BY_CONDITION = gql`
  mutation ExportPricingFailureRevisionByCondition($input: QueryPricingByConditionInput!) {
    exportPricingFailureRevisionByCondition(input: $input)
  }
`;

export interface ExportPricingFailureRevisionByConditionVariables {
  input: {
    clientIds?: number[] | null;
    businessAtStart?: string | null;
    businessAtEnd?: string | null;
    businessTimeZoneId?: string | null;
    pricingErrorCode?: string | null;
    pricingNodeCode?: string | null;
    businessScenarioCode?: number | null;
    isSuccess?: boolean | null;
    page?: number;
    pageSize?: number;
    cursor?: string | null;
    batchPages: number;
  };
}

export interface ExportPricingFailureRevisionByConditionResponse {
  exportPricingFailureRevisionByCondition: string;
}

